import axios from 'axios'
import weui from 'weui.js'

// 超时时间
// axios.defaults.timeout = 5000

// http请求拦截器
let loadinginstace
axios.interceptors.request.use(config => {
  if (config.showLoading) {
    // ui Loading方法
    loadinginstace = weui.loading('loading')
  }
  return config
}, error => {
  if (loadinginstace) {
    loadinginstace.hide()
  }
  weui.topTips('加载超时')
  return Promise.reject(error)
})

// http响应拦截器
axios.interceptors.response.use(data => {
  // 响应成功关闭loading
  if (loadinginstace) {
    loadinginstace.hide()
  }
  return data
}, error => {
  if (loadinginstace) {
    loadinginstace.hide()
  }
  weui.topTips('加载超时')
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/common/axios.js